import React, {useEffect, useState} from 'react';
import cn from "classnames";
import ReactTooltip from "react-tooltip";
import {TableHeader} from "./TableHeader";
import BackButton from "../../../../components/utils/BackButton";
import Select from "react-select";
import {useDispatch, useSelector} from "react-redux";
import { fetchGoods, fetchRawsList, updateInvoice } from "../../../../action";
import swal from 'sweetalert';
import {fetchWriteOffFormReasons} from "../../../../action/reasons";
import { reasonsLoadingSelector, reasonsSelector } from "../../../../selectors/forms";
import ErrorContainer from "../../../../components/utils/ErrorContainer";
import { createWriteoff, fetchWriteoff, updateWriteoff } from '../../../../action/writeoff';
import { isEmpty } from 'lodash';
import { fetchFilials } from '../../../../action/handbook';
import { fromStore } from '../../../../selectors';
import { loaderRawSelector, rawListSelector } from '../../../../selectors/raw';
import { styles } from '../../../../containers/goods/styles';
import Loader from '../../../../components/utils/Loader';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import DateInput from '../../../../components/utils/DateInput';
import moment from 'moment';
import { parseNumToFixed, roundToFixed } from '../../../../utils/common';
import request from '../../../../action/utils/request';
import { urls } from '../../../../constants/app';
import { getGoodWithReceipeData } from '../../../../action/recipes';


const WriteOffForm = ({ match, history }) => {
    const {id} = match.params;
    const dispatch = useDispatch();

    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointsLoading = useSelector(state => state.loaders.filials);
    const raws = useSelector(rawListSelector);
    const goods = useSelector(state => state.good.list);
    const goodsLoading = useSelector(fromStore.loaderGoodsSelector);
    const reasons = useSelector(reasonsSelector);

    const reasonsLoading  = useSelector(reasonsLoadingSelector);
    const rawMaterialsLoading = useSelector(loaderRawSelector);

    const loading = useSelector(state => state.loaders.writeoff);
    const productsLoading = rawMaterialsLoading || goodsLoading;
    const user = useSelector(state => state.user.info);

    const initData = {
        point: null,
        date: new Date(),
        note: '',
        totalSum: 0,
        writeoffreason: null,
        status: true,
        products: [],
        changeLog: {},
    }

    const [data, setData] = useState(initData);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [ prevProducts, setPrevProducts ] = useState([]);
    const [rawsPrices, setRawsPrices] = useState({});
    const [loadCostprice, setLoadCostprice] = useState(false);

    const setWriteoff = (field) => (value) => {
        const updated = { ...data };
        let dataValue = null;
        if (value) {
            if (value.value) {
                dataValue = value.value;
            } else {
                dataValue = value;
            }
        }

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;

            const data = { 
                old: updated[field] || null, 
                new: dataValue,
                time,
                username,
            };

            const currentLog = updated.changeLog[date] || {};
            const updatedLog = { ...currentLog, [field]: data };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        updated[field] = dataValue;
        setData(updated);
    }

    const setPoint = (point) => {
        if (point && !point.enableConsumption) return swal({
            title: `Создание списания на филиале ${point.label} невозможно`,
            text: '"Списание сырья" отключено',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        const updated = { ...data };        

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;

            const dataPoint = { 
                old: updated.point ? updated.point.id ? updated.point.id : updated.point : null, 
                new: (point && point.value) ? point.value : null,
                time,
                username,
            }

            const currentLog = updated.changeLog[date] || {};
            const updatedLog = { ...currentLog, point: dataPoint };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        let dataValue = null;
        if (point) dataValue = (point && point.value) ? point.value : null;
        updated.point = dataValue;
        setData(updated);
    }

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(raws)) dispatch(fetchRawsList());
        if (isEmpty(goods)) dispatch(fetchGoods());
        if (isEmpty(reasons)) dispatch(fetchWriteOffFormReasons());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        const getData = async () => {
            const res = await dispatch(fetchWriteoff(id));
            const changeLog = res.changeLog ? res.changeLog : {};
            const point = res.point ? res.point.id ? res.point.id : res.point : null;
            setData({...res, point, changeLog});
            if (res && res.products && res.products.length > 0) {
                const prevProducts = res.products.map(obj => ({ ...obj }));
                setPrevProducts(prevProducts);
            }
        }
        if (id) getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (loading || productsLoading) return (
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const pointOptions = points.map(point => ({
        value: point.id,
        label: renderPointLabel(point),
        enableConsumption: point.enableConsumption || false,
    }));

    const reasonOptions = reasons.map(reason => ({
        value: reason.id,
        label: reason.name,
    }));

    const getChangedProducts = () => {
        const sended = { ...data };
        const prevMap = new Map(prevProducts.map((prev) => [`${prev.id}_${prev.type}`, prev]));

        const result = sended.products.reduce((acc, product) => {
            const key = `${product.id}_${product.type}`;
            const prev = prevMap.get(key);
            if (prev) {
                const prevQuantity = prev.quantity;
                const newQuantity = product.quantity;
                if (prevQuantity !== newQuantity) {
                    if (prevQuantity > newQuantity) {
                        const quantity = parseNumToFixed(prevQuantity - newQuantity, 3);
                        const change = {
                            type: 'return',
                            quantity
                        }
                        const dataProduct = {...product, change};
                        acc.changedProducts.push(dataProduct);
                    } else {
                        const quantity = parseNumToFixed(newQuantity - prevQuantity, 3);
                        const change = {
                            type: 'invoice',
                            quantity
                        }
                        const dataProduct = {...product, change};
                        acc.changedProducts.push(dataProduct);
                    }
                }
                acc.found.add(key);
            } else {
                acc.newProducts.push({...product});
            }
            return acc;
        }, { changedProducts: [], newProducts: [], found: new Set() });
        
        for (const [key, prevProduct] of prevMap.entries()) {
            if (!result.found.has(key)) result.deletedProducts.push({...prevProduct});
        }

        delete result.found;
        return result;
    }

    const getDataConsumption = async (point, invoicesChanges, products, date) => {
        const { newProducts, changedProducts, deletedProducts } = products;
        let invoicesChangesResult = invoicesChanges;
    
        const getRawQuantity = (raw, field) => {
            if (raw.count) {
                return raw.count[field] ? raw.count[field] : raw.count.default || 0;
            } else if (raw.quantity) {
                return raw.quantity[field] ? raw.quantity[field] : raw.quantity.default || 0;
            }
            return 0;
        };
    
        const normalizedProducts = (arr) => {
            return arr.map((product) => {
                if (product.type !== 'good') return { ...product, count: product.quantity , id: parseInt(product.id) };
                if (typeof product.id === 'string') {
                    const parts = product.id.split('_');
                    const idNum = parseInt(parts[0]);
                    if (parts.length > 1) {
                        const modIdNum = parseInt(parts[1]);
                        if (!isNaN(modIdNum)) return { ...product, count: product.quantity, id: idNum, modId: modIdNum, isMod: true };
                    }
                    return { ...product, count: product.quantity, id: idNum };
                }
                return { ...product, count: product.quantity, id: parseInt(product.id) };
            }).filter(item => item.id);
        };
    
        const getGoodsWithReceipeData = async (arr) => {
            return await Promise.all(arr.map(async (product) => {
                if (product.type === 'raw') return { ...product, receipeData: [{ id: product.id, count: {default: 1} }] };
                const receipeData = await dispatch(getGoodWithReceipeData(product, true, new Date(date)));
                if (receipeData.error) return product;
                return { ...product, receipeData };
            }));
        };
    
        const getRaws = (arr) => {
            const rawsMap = {};
            arr.forEach((product) => {
                if (!product.receipeData || product.receipeData.length === 0) return;
                product.receipeData.forEach((raw) => {
                    const field = product.modId || 'default';
                    const quantity = getRawQuantity(raw, field);
                    const totalCount = parseNumToFixed(quantity * (product.count || 1), 3);
                    const key = raw.id;
                    if (rawsMap[key]) {
                        rawsMap[key].count = parseNumToFixed(rawsMap[key].count + totalCount, 3);
                    } else {
                        rawsMap[key] = { ...raw, count: totalCount, balance: 0 };
                    }
                });
            });
            return Object.values(rawsMap);
        };
    
        const changedInvoiceProduct = (changedProducts || []).filter((product) => product.change && product.change.type && product.change.type === 'invoice').map((product) => ({...product, quantity: product.change.quantity}));
        const sendedProductsInvoice = normalizedProducts([...(newProducts || []), ...changedInvoiceProduct]);
        const sendedProductsWithReceipt = await getGoodsWithReceipeData(sendedProductsInvoice);
    
        let invoices = [];
        const invoiceParams = { point: point.id, date_lte: new Date(date) };
    
        await Promise.all(getRaws(sendedProductsWithReceipt).map(async (raw) => {
            const params = { ...invoiceParams, rawId: raw.id };
            while (raw.balance < raw.count) {
                if (invoices.length > 0) {
                    const usedInvoices = invoices.filter((invoice) => invoice.rawId === raw.id);
                    if (usedInvoices.length > 0) {
                        const id_nin = usedInvoices.flatMap(inv => [inv.id, ...(inv.excludeIds || [])]);
                        if (id_nin.length) params.id_nin = id_nin;
                    }
                }
                try {
                    const invoiceByRaw = await request({ method: 'get', url: urls.invoiceforms + '/getNotRealizationInventory', params });
                    if (invoiceByRaw && !invoiceByRaw.error) {
                        invoices.push({ ...invoiceByRaw, rawId: raw.id });
                        const invoiceRaw = invoiceByRaw.rawMaterials.find(r => r.id === raw.id);
                        raw.balance = raw.balance + (invoiceRaw.balance || invoiceRaw.quantity || 0);
                    } else {
                        break;
                    }
                } catch {
                    break;
                }
            }
            return raw;
        }));
    
        invoices = invoices.reduce((acc, invoce) => {
            if (!acc.some((item) => item.id === invoce.id)) acc.push(invoce);
            return acc;
        }, []).sort((a, b) => new Date(a.date) - new Date(b.date));
    
        sendedProductsInvoice.forEach((product) => {
            const goodId = product.id;
            const modId = product.idMod
            const goodWithReceipeData = sendedProductsWithReceipt.find((item) => item.id === goodId);
            if (!goodWithReceipeData || !goodWithReceipeData.receipeData) return;
    
            goodWithReceipeData.receipeData.forEach((rawData) => {
                const field = modId || 'default';
                const quantity = getRawQuantity(rawData, field);
                const count = parseNumToFixed(quantity * (product.count || 1), 3);
                const receipeRaw = { ...rawData, count, balance: count };
                const idsInvoices = [];
    
                while (receipeRaw.balance > 0) {
                    const invoiceRaw = invoices.find((invoice) => {
                        if (idsInvoices.includes(invoice.id)) return false;
                        return invoice.rawMaterials.some((raw) => raw.id === receipeRaw.id && raw.balance > 0);
                    });
    
                    if (invoiceRaw) {
                        idsInvoices.push(invoiceRaw.id);
                        const raw = invoiceRaw.rawMaterials.find(r => r.id === receipeRaw.id && r.balance > 0);
                        const taken = Math.min(raw.balance, receipeRaw.balance);
    
                        invoicesChangesResult.push({
                            id: invoiceRaw.id,
                            date: invoiceRaw.date,
                            rawId: raw.id,
                            changeBalance: taken,
                        });

                        raw.balance = parseNumToFixed(raw.balance - taken, 3);
                        receipeRaw.balance = parseNumToFixed(receipeRaw.balance - taken, 3);

                        if (raw.balance === 0) raw.dateRealization = moment().format('DD.MM.YYYY HH:mm:ss');

                        invoiceRaw.needUpdate = true;
                        if (invoiceRaw.rawMaterials.every((r) => r.balance <= 0)) invoiceRaw.fullRealization = true;
                    } else {
                        receipeRaw.balance = 0;
                    }
                }
            });
        });
    
        const invoicesToUpdate = invoices.filter((invoice) =>  invoice.needUpdate);
        await Promise.all(invoicesToUpdate.map((item) => {
            if (!item || !item.id) return null;
            const data = {
                rawMaterials: item.rawMaterials,
                dateRealization: item.dateRealization,
                fullRealization: item.fullRealization,
            };
            return dispatch(updateInvoice(item.id, data));
        }));
    
        const changedReturnProduct = (changedProducts || []).filter((product) => product.change && product.change.type && product.change.type === 'return').map((product) => ({ ...product, quantity: product.change.quantity }));
        const sendedProductsReturn = normalizedProducts([...(deletedProducts || []), ...changedReturnProduct]);
        const sendedProductsReturnWithReceipt = await getGoodsWithReceipeData(sendedProductsReturn);
    
        const returnOperations = [];
    
        sendedProductsReturnWithReceipt.forEach((product) => {
            const goodId = product.id;
            const modId = product.idMod;
            const goodWithReceipeData = sendedProductsReturnWithReceipt.find((item) => item.id === goodId);
            if (!goodWithReceipeData || !goodWithReceipeData.receipeData) return;
    
            goodWithReceipeData.receipeData.forEach((rawData) => {
                const field = modId || 'default';
                const quantity = getRawQuantity(rawData, field);
                const count = parseNumToFixed(quantity * (product.count || 1), 3);
                const receipeRaw = { ...rawData, count, balance: count };
    
                while (receipeRaw.balance > 0) {
                    const availableChanges = invoicesChangesResult.filter((change) => change.rawId === receipeRaw.id && change.changeBalance > 0).sort((a, b) => new Date(b.date) - new Date(a.date));
                    if (availableChanges.length === 0) break;
    
                    for (let change of availableChanges) {
                        if (receipeRaw.balance === 0) break;
                        const returnAmount = Math.min(change.changeBalance, receipeRaw.balance);
    
                        returnOperations.push({
                            id: change.id,
                            rawId: change.rawId,
                            changeBalance: returnAmount,
                        });
    
                        change.changeBalance = parseNumToFixed(change.changeBalance - returnAmount, 3);
                        receipeRaw.balance = parseNumToFixed(receipeRaw.balance - returnAmount, 3);
                    }
                }
            });
        });
    
        if (returnOperations.length > 0) {
            const resultReturn = await request({ method: 'post', url: `${urls.invoiceforms}/returnBalanceRaw`, data: { invoicesChanges: returnOperations } });
            if (resultReturn === 'success') {
                invoicesChangesResult = invoicesChangesResult.filter((change) => change.changeBalance > 0).map(({ needReturn, ...rest }) => rest);
            }
        }
    
        return { invoicesChanges: invoicesChangesResult };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const sended = { ...data };

        sended.products = sended.products.filter((raw) => {
            if (!raw.id) return false;
            if (raw.price || raw.totalPrice || raw.quantity) return true;
            return false;
        }).map((product) => {
            delete product.modifications;
            return product;
        });

        sended.totalSum = totalSum;

        if (isEmpty(sended.products)) {
            setData(sended);
            return swal({
                title: "Нет данных о списанных продуктах.",
                text: 'Добавьте данные о продуктах для сохранения списания.',
                icon: "warning",
                dangerMode: true,
                button: "Назад"
            }).then(() => {
                return false;                   
            });
        }

        const changedProductsData = getChangedProducts();
        const consumption = await getDataConsumption( sended.point, sended.invoicesChanges || [], changedProductsData, sended.date );
        sended.invoicesChanges = consumption ? consumption.invoicesChanges || null : sended.invoicesChanges;

        if (id) {
            const result = await dispatch(updateWriteoff(id, sended));
            if (result) {
                return swal({
                    title: `Списание ${result} успешно обновлено`,
                    icon: "success",
                    button: "Ок"
                }).then(() => {
                    return history.goBack();;                   
                });
            }
        } else {
            const result = await dispatch(createWriteoff(sended));
            if (result) {
                return swal({
                    title: `Списание ${result} успешно создано`,
                    icon: "success",
                    button: "Ок"
                }).then(() => {
                    return history.goBack();;                   
                });
            }
        }
        
    };

    const addRow = (type) => {
        const updated = { ...data };
        updated.products.push({
            name: null,
            price: 0,
            totalPrice: 0,
            quantity: 0,
            category: {},
            type,
        });
        setData(updated);
        setIsDropdownOpen(false);
    };

    const deleteRow = (index) => {
        const updated = { ...data };
        if (id) {
            const raw = updated.products.find((raw, rawIndex) => index === rawIndex);
            if (raw.id) {
                const date = moment().format('YYYY.MM.DD');
                const time = moment().format('HH:mm:ss');
                const username = user ? user.name ? user.name : user.username : null;
                
                const deletedProduct = {
                    id: raw.id || null,
                    name: raw.name || null,
                    type: raw.type || null,
                    time,
                    username,
                };
                
                const currentLog = updated.changeLog[date] || {};
                const deletedProducts = [ ...(currentLog.deletedProducts || []), deletedProduct ];
                const updatedLog = { ...currentLog, deletedProducts };
                updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
            }
        }
        updated.products = updated.products.filter((raw, rawIndex) => index !== rawIndex);
        setData(updated);
    };

    const renderName = (item, type) => {
        let categoryText;
        let typeText;

        if (type === 'good') {
            typeText = '(товар)';
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            if (type === 'raw') {
                typeText = '(сырье)';
            } else {
                typeText = '(п/ф)';
            }
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}` : `${item.name || `Наименование продукта id ${item.id} не определено`} ${typeText}`
    }

    const availableOptions = (id, type) => {
        let arr = null;
        if (type === 'raw') arr = raws.filter((raw) => raw.productscategory.type === 'raw');
        if (type === 'semi') arr = raws.filter((raw) => raw.productscategory.type === 'semi');
        if (type === 'good') arr = goods;
        const result = arr.filter((item) => {
            
            if (item.id === id) return true;
            if (data.products.some((draw) => draw.id === item.id && draw.type === type)) return false;
            return true;
        })
        .map((item) => {
            return {
                label: renderName(item, type),
                value: item.id,
            }
        }).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
        return result;
    };

    const getProductValue = (id, type, name) => {
        if (!id || !type) return;
        let productId = id;
        let idMod = null;
        let arr = null;

        if (type === 'raw' || type === 'semi') {
            arr = raws;
        } else {
            arr = goods;
        }

        if (typeof id === 'string') [productId, idMod] = id.split('_')
        
        if (!arr) return;

        const result = arr.find((item) => item.id === parseInt(productId));
        if (!result || !result.id) return { value: parseInt(productId), label: name, measure: null, idMod: idMod ? parseInt(idMod) : null }
        return { value: result.id, label: renderName(result, type), measure: result.measure, idMod: idMod ? parseInt(idMod) : null, modifications: result.modifications}
    }

    const getLastInvoice = async (rawId) => { 
        const params = {
            _sort: 'date:desc',
            ignoreBalance: true,
            rawId,
            point: data.point,
        };

        let result;

        try {
            result = await request({ method: 'get', url: `${urls.invoiceforms}/getNotRealizationInventory`, params});
        } catch (err) {
            return;
        }
        if (result && !result.error) return result;
        return;
    }

    const getRawPrice = async (raw) => {        
        const key = data.point ? `${raw.id}_${data.point}` : raw.id;
        
        if (rawsPrices[key]) return rawsPrices[key];

        let price = roundToFixed(raw.last_price, 4);

        if (!data.point) {
            const updated = { ...rawsPrices, [key]: price };
            setRawsPrices(updated);
            return price;
        }

        const invoice = await getLastInvoice(raw.id);
        if (!invoice) {
            const updated = { ...rawsPrices, [key]: price };
            setRawsPrices(updated);
            return price;
        }

        const rawData = invoice.rawMaterials.find((item) => item.id === raw.id);
        if (!rawData) {
            const updated = { ...rawsPrices, [key]: price };
            setRawsPrices(updated);
            return price;
        }

        price = roundToFixed(rawData.price, 4);
        const updated = { ...rawsPrices, [key]: price };
        setRawsPrices(updated);
        return price;
    }

    const getAllRawPrices = async (good) => {
        const rawIds = new Set();
        
        if (good.receipeData) {
            good.receipeData.forEach(item => {
                if (item.id) rawIds.add(item.id);
            });
        }
        if (good && good.receipe && good.receipe.ingredients) {
            good.receipe.ingredients.forEach((ingredient) => {
                if (ingredient.type === 'raw' && ingredient.id) {
                    rawIds.add(ingredient.id);
                }
            });
        }

        const rawsPrices = {};
        const rawArray = Array.from(rawIds);
        
        for (let i = 0; i < rawArray.length; i++) {
            const rawId = rawArray[i];
            const raw = raws.find((item) => item.id === rawId);
            if (raw) {
                const price = await getRawPrice(raw);
                const key = data.point ? `${raw.id}_${data.point}` : raw.id; 
                rawsPrices[key] = price;
            }
        }

        return rawsPrices;
    }

    const getCostPriceGood = (receipeData, field = 'default', newRawPrices) => {
        if (!receipeData || receipeData.length === 0) return null;
        
        const resultRawPrices = !isEmpty(newRawPrices) ? newRawPrices : rawsPrices
        const sum = receipeData.reduce((acc, item) => {
            const rawData = raws.find((raw) => raw.id === item.id);
            if (!rawData) return acc;
            const key = data.point ? `${item.id}_${data.point}` : item.id;

            const price = roundToFixed(resultRawPrices[key], 4) || roundToFixed(rawData.last_price, 4);
            
            if (item.count && (item.count[field] != null)) {
                const quantity = item.count[field] ? roundToFixed(item.count[field], 3) : 0;
                acc += price * quantity;
            } else {
                const quantity = item.quantity && item.quantity[field] ? roundToFixed(item.quantity[field], 3) : 0;
                acc += price * quantity;
            }
            
            return acc;
        }, 0);
        
        return roundToFixed(sum);
    }

    const handleMaterialChange = async (index, option, type) => {
        const updated = { ...data };
        const { products } = updated;
        let entity = null;
        if (option && option.value && type !== 'good') entity = raws.find((raw) => raw.id === option.value);
        if (option && option.value && type === 'good') entity = goods.find((raw) => raw.id === option.value);

        let category = null;

        if (entity) {
            if (entity.productscategory && entity.productscategory.id) category = entity.productscategory.id;
            if (entity.category && entity.category.id) category = entity.category.id;
        }

        if (entity && (type === 'good' || type === 'semi')) {
            setLoadCostprice((products[index] && products[index].id) ? products[index].id : true);
            entity.receipeData = await dispatch(getGoodWithReceipeData({ ...entity, type }, true, new Date()));
            const newRawPrices = await getAllRawPrices(entity);
            setRawsPrices({ ...rawsPrices, ...newRawPrices });
            entity.costprice = getCostPriceGood(entity.receipeData, 'default', { ...rawsPrices, ...newRawPrices });
            setLoadCostprice(false);
        }

        const price = entity ? type === 'good' ? (entity.price || 0) : (entity.last_price || 0) : 0;

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;
            
            const addedProduct = {
                old: {
                    id: products[index] && products[index].id ? products[index].id : null,
                    type: products[index] && products[index].type ? products[index].type : null,
                    name: products[index] && products[index].name ? products[index].name : null,
                },
                new: {
                    id: entity ? entity.id : null,
                    type,
                    name: entity ? renderName(entity, type) : null,
                },
                time,
                username,
            };
            
            const currentLog = updated.changeLog[date] || {};
            const productsAdd = [ ...(currentLog.productsAdd || []), addedProduct ];
            const updatedLog = { ...currentLog, productsAdd };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        products[index] = {
            ...products[index],
            type,
            name: entity ? renderName(entity, type) : null,
            id: entity ? entity.id : null,
            price: entity.costprice ? entity.costprice : price,
            totalPrice: (products[index].quantity || 0) * price,
            category,
            modifications: entity.modifications ? entity.modifications : null,
        }

        updated.products = products;
        setData(updated);
    }

    const handleChange = (index, field, value) => {
        const updated = { ...data };
        const { products } = updated;

        if (id) {
            const date = moment().format('YYYY.MM.DD');
            const time = moment().format('HH:mm:ss');
            const username = user ? user.name ? user.name : user.username : null;
            
            const product = {
                id: products[index].id || null,
                name: products[index].name || null,
                type: products[index].type || null,
                [field]: {
                    old: products[index][field] || null,
                    new: value,
                },
                time,
                username,
            };
            
            const currentLog = updated.changeLog[date] || {};
            const productsData = [ ...(currentLog.products || []), product ];
            const updatedLog = { ...currentLog, products: productsData };
            updated.changeLog = { ...updated.changeLog, [date]: updatedLog };
        }

        products[index][field] = value;

        switch (field) {
            case 'price': {
                if (products[index].quantity) products[index].totalPrice = parseFloat(products[index].quantity * value);
                break;
            }
            case 'totalPrice': {
                if (products[index].quantity) products[index].price = parseFloat(value / products[index].quantity);
                break;
            }
            case 'quantity': {
                if (products[index].price) products[index].totalPrice = parseFloat(products[index].price * value);
                break;
            }
            default: {
                break
            }
        }
        
        updated.products = products;
        setData(updated);
    }

    const getPriceGood = (good, mod) => {
        const price = good.originalPrice ? good.originalPrice : good.price;
        if (!mod) return parseNumToFixed(price);

        const getModPrice = (price, mod) => {
            if (!mod || mod.price === 0) return parseNumToFixed(price);
            if (!price) return parseNumToFixed(mod.price);

            if (mod.condition === 'equal') return parseNumToFixed(mod.price);
            if (mod.condition === 'plus') return parseNumToFixed(parseFloat(price + mod.price));
            return parseNumToFixed(parseFloat(price * mod.price));
        }

        return getModPrice(price, mod);
    }

    const changeModGood = (index, mod) => {
        const updated = { ...data };
        const { products } = updated;

        let originalPrice = products[index].originalPrice;
        if (!originalPrice && mod) originalPrice = products[index].price;
        let id = products[index].id;

        const price = getPriceGood({ ...products[index], originalPrice }, mod);
        if (typeof id === 'string') id = parseInt(id.split('_')[0]);
        let costprice;
        if (mod && mod.id) {
            id = `${id}_${mod.id}`
            costprice = getCostPriceGood(products[index].receipeData, String(mod.id));
        } else {
            costprice = getCostPriceGood(products[index].receipeData, 'default');
        }
        products[index] = {
            ...products[index],
            id,
            idMod: mod ? mod.id : null,
            price: costprice ? costprice : price,
            originalPrice,
            totalPrice: parseNumToFixed(parseFloat((products[index].quantity || 0) * price)),
        };
        updated.products = products;
        setData(updated);
    }

    const isValid = () => {
        if (isEmpty(data.products) || !data.writeoffreason || !data.date || !data.point) return false;
        return true;
    }

    const totalSum = parseNumToFixed(parseFloat(data.products.reduce((sum, row) => sum + parseFloat(row.totalPrice || 0), 0)));

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid"
                         style={{padding: 0}}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div
                                    style={{position: 'relative', marginBottom: 0}}
                                    className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                                >
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container  kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <h3 className="kt-subheader__title">Списание</h3>
                                                <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                <div className="kt-subheader__group" id="kt_subheader_search">
                                                    <BackButton/>
                                                    <button
                                                        onClick={handleSubmit}
                                                        className={cn({ 'btn btn-success  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loading })}
                                                        disabled={!isValid() || loading || !!loadCostprice}>
                                                        Сохранить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className='kt-subheader not-mt kt-grid_item'>
                                        <div className='kt-container kt-container--fluid'>
                                            <div className='kt-subheader__main' style={{ gap: '10px' }}>
                                                <div style={{width: 200, height: 50}}>
                                                    <DateInput
                                                    showPopperArrow={false}
                                                    placeholderText="Дата"
                                                    selected={new Date(data.date)}
                                                    onChange={setWriteoff('date')}
                                                    showTimeSelect
                                                    timeFormat="HH:mm:ss"
                                                    timeIntervals={1}
                                                    dateFormat="dd.MM.yyyy HH:mm:ss"
                                                    />
                                                </div>

                                                <div style={{width: 200, height: 50}}>
                                                    <Select
                                                    options={reasonOptions}
                                                    placeholder="Причина списания"
                                                    isClearable={true}
                                                    onChange={setWriteoff('writeoffreason')}
                                                    value={data.writeoffreason
                                                        ? data.writeoffreason.id 
                                                        ? { label: data.writeoffreason.name, value: data.writeoffreason.id } 
                                                        : reasonOptions.find((reason) => reason.id === data.writeoffreason) 
                                                        : null}
                                                    isLoading={reasonsLoading}
                                                    />
                                                </div>
                                                <div style={{width: 200, height: 50}}>
                                                    <Select
                                                    options={pointOptions}
                                                    placeholder="Филиал"
                                                    isClearable={true}
                                                    value={data.point ? pointOptions.find((item) => item.value === data.point) : null}
                                                    onChange={setPoint}
                                                    isLoading={pointsLoading}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='kt-subheader not-mt kt-grid_item'>
                                        <div className='kt-container kt-container--fluid'>
                                            <div className='kt-subheader__main' style={{ gap: '10px' }}>
                                                <div style={{width: 175, height: 50}}>
                                                <textarea
                                                className="custom-textarea"
                                                value={data.note}
                                                onChange={(e) => setWriteoff('note')(e.target.value)}
                                                minLength={3}
                                                maxLength={500}
                                                placeholder="Примечание"
                                                />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <table className="kt-datatable__table" style={{minHeight: '700px'}}>
                                        <ErrorContainer field='writeOffCreationForm' hasCloseButton={true} style={{ margin: 25 }} />
                                        <TableHeader/>
                                        <tbody className="kt-datatable__body">
                                        <>
                                            {data.products.map((product, index) => {
                                                const productData = product ? getProductValue(product.id, product.type, product.name) : null;
                                                return (
                                                <tr key={index} className="kt-datatable__row">
                                                    <td width="180px" className="kt-datatable__cell">
                                                        <Select
                                                            isDisabled={!data.point || loadCostprice === product.id || (loadCostprice === true && (product.type === 'good' || product.type === 'semi') && !product.id)}
                                                            options={availableOptions(product.id, product.type)}
                                                            placeholder={`Введите ${
                                                                product.type === "raw"
                                                                    ? "сырье"
                                                                    : product.type === "semi"
                                                                        ? "полуфабрикат"
                                                                        : "товар"
                                                            }...`}
                                                            value={productData ? productData: null}
                                                            onChange={option => handleMaterialChange(index, option, product.type)}
                                                            isLoading={productsLoading || loadCostprice === product.id || (loadCostprice === true && (product.type === 'good' || product.type === 'semi') && !product.id)}
                                                        />
                                                        {
                                                            productData && productData.modifications && productData.modifications.length > 0 && 
                                                            <div className='neworder_pizza_modification_button_div' style={{ marginTop: '5px' }}>
                                                                <button className={`neworder_pizza_modification_button ${!product.idMod ? 'actived' : ''}`} onClick={() => changeModGood(index, null)}>30см</button>
                                                                <button className={`neworder_pizza_modification_button ${product.idMod ? 'actived' : ''}`} onClick={() => changeModGood(index, productData.modifications.find((mod) => mod.active && !mod.default))}>36см</button>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td width="40px" className="kt-datatable__cell">
                                                        <span>
                                                            {!product.id ? '' : product.type === 'good' ? 'шт.' : (MEASURES_RAW[productData.measure] || '')}
                                                        </span>
                                                    </td>
                                                    <td width="120px" className="kt-datatable__cell">
                                                        <input
                                                            disabled={!data.point || loadCostprice === product.id || (loadCostprice === true && (product.type === 'good' || product.type === 'semi') && !product.id)}
                                                            type="number"
                                                            step="0.001"
                                                            className="form-control"
                                                            value={product.quantity}
                                                            onChange={(e) => handleChange(index, 'quantity', parseNumToFixed(parseFloat(e.target.value), 3))}
                                                            onFocus={e => e.target.select()}
                                                        />
                                                    </td>
                                                    <td width="120px" className="kt-datatable__cell">
                                                        <input
                                                            disabled={!data.point || loadCostprice === product.id || (loadCostprice === true && (product.type === 'good' || product.type === 'semi') && !product.id)}
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            value={product.price}
                                                            onChange={(e) => handleChange(index, 'price', parseNumToFixed(parseFloat(e.target.value)))}
                                                            onFocus={e => e.target.select()}
                                                        />
                                                    </td>
                                                    <td width="310px" className="kt-datatable__cell">
                                                        <input
                                                            disabled={!data.point || loadCostprice === product.id || (loadCostprice === true && (product.type === 'good' || product.type === 'semi') && !product.id)}
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            value={product.totalPrice}
                                                            onChange={(e) => handleChange(index, 'totalPrice', parseNumToFixed(parseFloat(e.target.value)))}
                                                            style={{width: "195px"}}
                                                            onFocus={e => e.target.select()}
                                                        />
                                                    </td>
                                                    <td align="right" width="180px" className="kt-datatable__cell">
                                                        <button
                                                            className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                            onClick={() => deleteRow(index)}
                                                        >
                                                            <i className="la la-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )})}
                                            <tr>
                                                <td colSpan={5}>
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '10px 20px',
                                                            borderTop: '1px solid #e0e0e0',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <div style={{position: 'relative'}}>
                                                            <button
                                                                disabled={!data.point}
                                                                className="btn btn-primary"
                                                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                                style={{position: 'relative'}}
                                                            >
                                                                Добавить
                                                            </button>
                                                            {isDropdownOpen && (
                                                                <div className="custom-dropdown-menu">
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => addRow('raw')}
                                                                    >
                                                                        Добавить Сырье
                                                                    </button>
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => addRow('semi')}
                                                                    >
                                                                        Добавить Полуфабрикат
                                                                    </button>
                                                                    <button
                                                                        className="custom-dropdown-item"
                                                                        onClick={() => addRow('good')}
                                                                    >
                                                                        Добавить Товар
                                                                    </button>
                                                                </div>
                                                            )}

                                                        </div>
                                                        <div style={{fontWeight: 'bold', marginLeft: '10px'}}>
                                                            <div>
                                                                Общая сумма: {data.totalSum ? parseNumToFixed(data.totalSum) : parseNumToFixed(totalSum)}
                                                            </div>
                                                            {!data.point && <div style={{ fontSize: '10px', color: '#ff000083' }}> * Перед добавлением продуктов необходимо выбрать филиал</div>}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip
                        effect="solid"
                        type="dark"
                        place="top"
                    />
                </div>
            </div>
        </div>
    )
};

export default WriteOffForm;
